@if (show) {
<div class="modal-fullscreen">
  <div class="modal-header">
    <button type="button" class="btn btn-outline-secondary" (click)="onClose()">Retour</button>

  </div>
  <div class="modal-container">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <h3 style="text-align: center; width: 75%; margin: auto;">
        {{ nbVisuelsPrincipaux > 1 ? 'Choisissez vos visuels principaux' : 'Choisissez votre visuel principal' }}
      </h3>
      <button type="button" class="btn btn-primary start-generation-button" (click)="startGeneration()"
        [disabled]="!isButtonEnabled">
        Commencer la génération
      </button>
      <br />
      <p>Quelque soit le format, notre IA redimensionnera l'image et se chargera d'ajouter de nouveaux élements si
        besoin. </p>
      <!-- Section pour afficher les images sélectionnées lorsque GIF est activé -->
      @if (wantGif && selectedImages.length > 0) {
      <p>Choissisez l'ordre de vos images pour la création du GIF :</p>
      }
      @if (wantGif && nbVisuelsPrincipaux > 1) {
      <div class="visuel-selector">
        @for (visuel of selectedImages; track visuel; let idx = $index) {
        <button nbButton appearance="outline" status="primary" [class.active]="currentVisuelIndex === idx"
          (click)="currentVisuelIndex = idx">
          Visuel {{ idx + 1 }}
        </button>
        }
      </div>
      }
      <!-- For multiple visuels with GIFs -->
      @if (wantGif === true && nbVisuelsPrincipaux > 1) {
      <div>
        @if (selectedImages[currentVisuelIndex]?.length > 0) {
        <div class="container" [ngClass]="selectedRatioString" cdkDropList (cdkDropListDropped)="drop($event)"
          cdkDropListOrientation="horizontal">
          @for (selectedImage of selectedImages[currentVisuelIndex]; track selectedImage; let i = $index) {
          <div cdkDrag class="item selected-image-wrapper" [style.aspect-ratio]="aspectRatioStyle">
            <div class="delete-button" (click)="removeImage(i)">
              <i class="bi-trash"></i>
            </div>
            <img [src]="selectedImage" alt="Image" class="selected-image" />
          </div>
          }
        </div>
        }
      </div>
      }
      <!-- For multiple visuels and no GIF -->
      @if (wantGif === false && nbVisuelsPrincipaux > 1) {
      <div>
        @if (selectedImages.length > 0) {
        <div class="container" [ngClass]="selectedRatioString" cdkDropList (cdkDropListDropped)="drop($event)"
          cdkDropListOrientation="horizontal">
          @for (selectedImage of selectedImages; track selectedImage; let i = $index) {
          <div cdkDrag class="item selected-image-wrapper" [style.aspect-ratio]="aspectRatioStyle">
            <div class="delete-button" (click)="removeImage(i)">
              <i class="bi-trash"></i>
            </div>
            <img [src]="selectedImage" alt="Image" class="selected-image" />
          </div>
          }
        </div>
        }
      </div>
      }
      <!-- For unique visuels with GIFs -->
      @if (wantGif === true && nbVisuelsPrincipaux === 1) {
      <div>
        @if (selectedImages.length > 0) {
        <div class="container" [ngClass]="selectedRatioString" cdkDropList (cdkDropListDropped)="drop($event)"
          cdkDropListOrientation="horizontal">
          @for (selectedImage of selectedImages; track selectedImage; let i = $index) {
          <div cdkDrag class="item selected-image-wrapper" [style.aspect-ratio]="aspectRatioStyle">
            <div class="delete-button" (click)="removeImage(i)">
              <i class="bi-trash"></i>
            </div>
            <img [src]="selectedImage" alt="Image" class="selected-image" />
          </div>
          }
        </div>
        }
      </div>
      }
      <!-- For unique visuels and no GIF -->
      @if (wantGif === false && nbVisuelsPrincipaux === 1) {
      <div>
        @if (selectedImages.length > 0) {
        <div class="container" [ngClass]="selectedRatioString" cdkDropList (cdkDropListDropped)="drop($event)"
          cdkDropListOrientation="horizontal">

          @for (selectedImage of selectedImages; track selectedImage; let i = $index) {
          <div cdkDrag class="item selected-image-wrapper" [style.aspect-ratio]="aspectRatioStyle">
            <div class="delete-button" (click)="removeImage(i)">
              <i class="bi-trash"></i>
            </div>
            <img [src]="selectedImage" alt="Image" class="selected-image" />
          </div>
          }
        </div>
        }
      </div>
      }

      <!-- ✅ Bloc logo -->
      @if (nbVisuelsPrincipaux === 1 && enterpriseLogos.length > 0) {
      <div class="logo-selection-block">
        <div class="checkbox-logo-container">
          <label>
            <nb-checkbox [(checked)]="wantLogo" status="danger" (checkedChange)="updateButtonState()">
              {{ wantLogo ? "Désélectionner pour ne pas ajouter de logo" : "Je veux mon logo sur l'image" }}
            </nb-checkbox>
          </label>
        </div>

        @if (wantLogo) {
        <div class="logo-container">
          <p>Choisissez votre logo :</p>
          <div class="logo-list">
            <img *ngFor="let logo of enterpriseLogos" [src]="logo.image_url" [alt]="logo.label" class="enterprise-logo"
              (click)="onLogoClick(logo.image_url)" [class.selected]="selectedLogo === logo.image_url" />
          </div>
        </div>
        }
      </div>
      }

      @if (shouldDisplayRatioSelect) {
      <div class="ratio-select-block">
        <br>
        <label for="ratioSelect">
          Choisissez le ratio de votre {{ wantGif ? 'GIF' : 'visuel' }} <span *ngIf="!wantGif">(Optionnel)</span> :
        </label>
        <select id="ratioSelect" [(ngModel)]="selectedRatioString" style="margin-left: 8px;">
          @for (ratio of ratioOptions; track ratio.value) {
          <option [value]="ratio.value">{{ ratio.label }}</option>
          }
        </select>
      </div>
      }
      @if (nbVisuelsPrincipaux === 1) {
      <div class="checkbox-container">
        <label>
          <nb-checkbox [(checked)]="wantGif" status="danger" (checkedChange)="toggleGifPreference($event)">
            {{ wantGif ? "Désélectionner pour ne pas avoir de GIF" : "Je veux un GIF !" }}
          </nb-checkbox>
        </label>
      </div>
      }


      <!-- Search Bar for Adobe Stock Images -->
      @if (showAdobeStock$ | async) {
      <div class="search-bar">
        <input type="text" [(ngModel)]="searchTerm" placeholder="Rechercher des images sur Adobe Stock"
          class="form-control" (keyup.enter)="onSearch()" [disabled]="isSearching" />
        @if (errorSearchMessage) {
        <p class="error-message">{{ errorSearchMessage }}</p>
        }
      </div>
      }
      <div class="images-container" [class.grayed-out]="isSearching">
        <label for="file-upload" class="custom-file-upload" [class.dragover]="isDragging"
          (dragover)="onDragOver($event)" (dragenter)="onDragEnter($event)" (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)">
          <button nbButton appearance="filled" status="danger" (click)="onButtonClick($event)">
            Charger une image
          </button>
          <p><br>Ou faire glisser un fichier image</p>
          @if (errorMessage) {
          <p class="error-message">{{ errorMessage }}</p>
          }
          <i class="fa fa-plus"></i>
        </label>
        <input id="file-upload" type="file" style="display:none;"
          (change)="onFileSelected($event); uploadSelectedFile()">
        @for (imageUrl of imageUrls; track imageUrl) {
        @if (imageUrl !== '0') {
        <div class="image-container" [class.selected]="isImageSelected(imageUrl)"
          (click)="onImageClick($event, imageUrl)">
          @if (imageUrl === 'loading') {
          <div class="loading-spinner">
            <div class="spinner"></div>
          </div>
          } @else {
          <img [src]="imageUrl" class="displayed-image" (load)="onImageLoad($event)" />
          @if (isImageSelected(imageUrl)) {
          <div class="selection-number">
            {{ getSelectionIndex(imageUrl) }}
          </div>
          }
          }
        </div>
        }
        }
        <!-- Upload button styled as an image with a "+" icon -->
      </div>
    </div>
  </div>
</div>
}

<!-- Template de dialogue pour afficher les messages d'erreur -->
<ng-template #dialogTemplate let-ref="dialogRef">
  <nb-card>
    <nb-card-body>{{ errorMessage }}</nb-card-body>
    <nb-card-footer>
      <div class="row">
        <div class="col text-center">
          <button nbButton status="success" (click)="ref.close()">OK</button>
        </div>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>

<ng-template #dialogGifTemplate let-ref="dialogRef">
  <nb-card>
    <nb-card-body>{{ errorMessageGif }}</nb-card-body>
    <nb-card-footer>
      <div class="row">
        <div class="col text-center">
          <button nbButton status="success" (click)="ref.close()">OK</button>
        </div>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>